export default "__VITE_ASSET__CTTwE8h2__"